import React from 'react';
import { useSelector } from 'react-redux';
import { beatWaveListSelector } from '../../wave/selectors/wave.selectors';
import { useStrip } from '../hooks/useStrip';
import { squareToPixel } from '../utils/graph.utils';
import { WaveCount } from './WaveCount';

const WAVE_COUNT_HEIGHT = squareToPixel(1 / 4);

export const QRSCount: React.FC = () => {
  const waves = useSelector(beatWaveListSelector);
  const displayedWaves = waves.filter(({ type }) => type === 'QRS');
  const { height } = useStrip();

  return (
    <g
      className='qrs-count'
      style={{
        transform: `translate(0px, ${height - WAVE_COUNT_HEIGHT}px)`,
      }}
    >
      {displayedWaves.map((wave, index) => (
        <WaveCount key={wave.id} waveId={wave.id} count={index + 1} />
      ))}
    </g>
  );
};
